import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EventsOrActionsOf, GenericBlocService } from 'src/app/shared/services/generic-bloc.service';
import { AccountService } from '../../services/account.service';
import { LoginAction, LoginActionPayloads, LoginEvent, LoginEventPayloads } from '../models/login-bloc.model';
import { RecoveryService } from '../../services/recovery.service';

@Injectable()
export class LoginBlocService extends GenericBlocService<LoginEventPayloads, LoginActionPayloads> {
  accountService = inject(AccountService);
  recoveryService = inject(RecoveryService);

  constructor() {
    super();
    this.events$.subscribe((event) => this.onEventEmission(event));
  }

  onEventEmission(event: EventsOrActionsOf<LoginEventPayloads>) {
    switch (event.name) {
      case LoginEvent.fetchToken:
        this.getToken(event.payload.username, event.payload.password);
        break;
      case LoginEvent.fetchUserInfo:
        this.getUserInfo();
        break;
      case LoginEvent.loadBaseDataError:
        this.addAction(LoginAction.loadBaseDataError, {});
        break;
      case LoginEvent.recoverPassword:
        this.onRecovery(event.payload.username);
        break;
    }
  }

  private getToken(username: string, password: string) {
    this.accountService.getToken(username, password).subscribe({
      next: (token) => this.addAction(LoginAction.tokenFetched, { token }),
      error: (httpError: HttpErrorResponse) => this.addAction(LoginAction.tokenFetchedFailed, { httpError }),
    });
  }

  private getUserInfo() {
    this.accountService.getCurrentUserInfo().subscribe({
      next: (currentUser) => this.addAction(LoginAction.userInfoFetched, { currentUser }),
      error: (httpError: HttpErrorResponse) => this.addAction(LoginAction.userInfoFetchedFailed, { httpError }),
    });
  }

  private onRecovery(username: string) {
    this.recoveryService.generatePassword(username).subscribe({
      next: () => this.addAction(LoginAction.passwordRecovered, {}),
      error: (error: HttpErrorResponse) => this.addAction(LoginAction.passwordRecoveredFailed, { error }),
    });
  }
  
}
